import invoiceAuditService from "../api/server/invoiceAuditService";
export const INVOICE_AUDIT_NAMESPACE = "invoiceAuditModule";

var fakeService;
const loadFakeService = async () => {
  if (fakeService) return fakeService;
  return import(
    `../api/${process.env.VUE_APP_SERVICE_FOLDER}/invoiceAuditService`
  ).then(x => {
    fakeService = x.default;
    return fakeService;
  });
};

var services = {
  api:
    (process.env.VUE_APP_SERVICE_FOLDER === "fakes" &&
      process.env.NODE_ENV === "development") ||
    process.env.NODE_ENV === "test"
      ? loadFakeService()
      : Promise.resolve(invoiceAuditService)
};

const state = {};
const actions = {
  async save(context, formData) {
    var api = await services.api;
    return api.save(formData).then(function(value) {
      return value;
    });
  }
};

const mutations = {};

const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  services
};
